import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select';

const HclSatheeAssessment = () => {
    const API_URL = process.env.REACT_APP_API_URL;
    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState('');
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    
    const initForm = { pre_max_marks: '', mid_max_marks: '', post_max_marks: '', pre_marks: '', mid_marks: '', post_marks: '', remarks: '' };
    const [form, setForm] = useState(initForm);
    const [history, setHistory] = useState([]);

    useEffect(() => { loadStudents(); }, []);

    const loadStudents = () => {
        Axios.get(`${API_URL}/sathee/student`, { headers: { Authorization: localStorage.getItem('token') } })
             .then(res => setStudents(res.data.data)).catch(console.error);
    };

    const handleStudentSelect = async (studentId) => {
        setSelectedStudent(studentId);
        if (!studentId) {
            setForm(initForm);
            setHistory([]);
            return;
        }
        
        const hdrs = { headers: { Authorization: localStorage.getItem('token') } };
        try {
            const res = await Axios.get(`${API_URL}/sathee/assessment/${studentId}`, hdrs);
            if (res.data.data) setForm(res.data.data);
            else setForm(initForm);

            const histRes = await Axios.get(`${API_URL}/sathee/assessment/history/${studentId}`, hdrs);
            setHistory(histRes.data.data);
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } catch (err) {
            console.error(err);
        }
    };

    const filteredStudents = students.filter(s => 
        s.student_name.toLowerCase().includes(searchTerm.toLowerCase()) || 
        s.id.toString().includes(searchTerm)
    );

    const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async e => {
        e.preventDefault();
        if (!selectedStudent) return toast.error('Select a student first');
        
        setLoading(true);
        try {
            const res = await Axios.post(`${API_URL}/sathee/assessment`, { ...form, student_id: selectedStudent }, { headers: { Authorization: localStorage.getItem('token') } });
            toast.success(res.data.message);
            // Reload history and students table
            const histRes = await Axios.get(`${API_URL}/sathee/assessment/history/${selectedStudent}`, { headers: { Authorization: localStorage.getItem('token') } });
            setHistory(histRes.data.data);
            loadStudents();
        } catch (err) {
            toast.error(err.response?.data?.message || 'Failed to save');
        }
        setLoading(false);
    };

    const IStyle = { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', boxSizing: 'border-box' };

    const studentOptions = students.map(s => ({
        value: s.id,
        label: `${s.student_name} (ID: ${s.id} - ${s.preparing_for})`
    }));

    return (
        <div style={{ padding: 20 }}>
            <ToastContainer />
            <h2 style={{ marginBottom: 20 }}>Student Assessment</h2>
            <div style={{ background: '#fff', padding: 20, borderRadius: 10, boxShadow: '0 4px 10px rgba(0,0,0,0.05)', marginBottom: 30 }}>
                <div style={{ marginBottom: 20 }}>
                    <label style={{ display: 'block', marginBottom: 5 }}>Select Student *</label>
                    <Select 
                        options={studentOptions}
                        value={studentOptions.find(o => o.value === selectedStudent) || null}
                        onChange={selectedOption => handleStudentSelect(selectedOption ? selectedOption.value : '')}
                        placeholder="-- Search or Select Student --"
                        isClearable
                        styles={{
                            control: (baseStyles) => ({
                                ...baseStyles,
                                padding: '4px',
                                borderRadius: '8px',
                                borderColor: '#ddd'
                            })
                        }}
                    />
                </div>

                <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 20 }}>
                    <div style={{ border: '1px solid #ddd', padding: 15, borderRadius: 8 }}>
                        <h4 style={{ margin: '0 0 10px 0' }}>Pre Assessment</h4>
                        <label>Max Marks</label>
                        <input type="number" style={{...IStyle, marginBottom: 10}} name="pre_max_marks" value={form.pre_max_marks || ''} onChange={handleChange} step="0.01" disabled={!selectedStudent} />
                        <label>Obtained Marks</label>
                        <input type="number" style={IStyle} name="pre_marks" value={form.pre_marks || ''} onChange={handleChange} step="0.01" disabled={!selectedStudent} />
                    </div>
                    <div style={{ border: '1px solid #ddd', padding: 15, borderRadius: 8 }}>
                        <h4 style={{ margin: '0 0 10px 0' }}>Mid Assessment</h4>
                        <label>Max Marks</label>
                        <input type="number" style={{...IStyle, marginBottom: 10}} name="mid_max_marks" value={form.mid_max_marks || ''} onChange={handleChange} step="0.01" disabled={!selectedStudent} />
                        <label>Obtained Marks</label>
                        <input type="number" style={IStyle} name="mid_marks" value={form.mid_marks || ''} onChange={handleChange} step="0.01" disabled={!selectedStudent} />
                    </div>
                    <div style={{ border: '1px solid #ddd', padding: 15, borderRadius: 8 }}>
                        <h4 style={{ margin: '0 0 10px 0' }}>Post Assessment</h4>
                        <label>Max Marks</label>
                        <input type="number" style={{...IStyle, marginBottom: 10}} name="post_max_marks" value={form.post_max_marks || ''} onChange={handleChange} step="0.01" disabled={!selectedStudent} />
                        <label>Obtained Marks</label>
                        <input type="number" style={IStyle} name="post_marks" value={form.post_marks || ''} onChange={handleChange} step="0.01" disabled={!selectedStudent} />
                    </div>
                    <div style={{ gridColumn: 'span 3' }}>
                        <label>Remarks</label>
                        <input style={IStyle} name="remarks" value={form.remarks || ''} onChange={handleChange} disabled={!selectedStudent} />
                    </div>

                    {form.improvement_percentage && (
                        <div style={{ gridColumn: 'span 3', padding: 15, background: '#e0e7ff', borderRadius: 8, color: '#4338ca', fontWeight: 'bold' }}>
                            Current Improvement: {form.improvement_percentage}%
                        </div>
                    )}

                    <div style={{ gridColumn: 'span 3', textAlign: 'right' }}>
                        <button type="button" onClick={() => handleStudentSelect('')} disabled={!selectedStudent} style={{ padding: '10px 20px', background: '#9ca3af', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', marginRight: 10, opacity: !selectedStudent ? 0.5 : 1 }}>
                            Clear
                        </button>
                        <button type="submit" disabled={loading || !selectedStudent} style={{ padding: '10px 20px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', opacity: (!selectedStudent || loading) ? 0.5 : 1 }}>
                            {loading ? 'Saving...' : 'Save Assessment'}
                        </button>
                    </div>
                </form>
            </div>

            <div style={{ background: '#fff', padding: 20, borderRadius: 10, boxShadow: '0 4px 10px rgba(0,0,0,0.05)', marginBottom: 30 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 15 }}>
                    <h3 style={{ margin: 0 }}>Registered Students</h3>
                    <input 
                        style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', width: '250px' }}
                        placeholder="Search by Name or ID..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                    />
                </div>
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 10, fontSize: '0.9rem' }}>
                        <thead>
                            <tr style={{ background: '#f8f9fa', textAlign: 'left' }}>
                                <th style={{ padding: 10 }}>ID</th>
                                <th>Name</th>
                                <th>Kendra</th>
                                <th>Exam</th>
                                <th>Pre (Obt/Max)</th>
                                <th>Mid (Obt/Max)</th>
                                <th>Post (Obt/Max)</th>
                                <th>Improvement</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredStudents.map(s => (
                                <tr key={s.id} style={{ borderBottom: '1px solid #ddd', background: selectedStudent === s.id ? '#e0e7ff' : 'transparent' }}>
                                    <td style={{ padding: 10 }}>{s.id}</td>
                                    <td>{s.student_name}</td>
                                    <td>{s.kendra_name || 'N/A'}</td>
                                    <td>{s.preparing_for}</td>
                                    <td>{s.pre_marks ? `${Number(s.pre_marks)}/${s.pre_max_marks ? Number(s.pre_max_marks) : '-'}` : '-'}</td>
                                    <td>{s.mid_marks ? `${Number(s.mid_marks)}/${s.mid_max_marks ? Number(s.mid_max_marks) : '-'}` : '-'}</td>
                                    <td>{s.post_marks ? `${Number(s.post_marks)}/${s.post_max_marks ? Number(s.post_max_marks) : '-'}` : '-'}</td>
                                    <td>{s.improvement_percentage ? `${s.improvement_percentage}%` : '-'}</td>
                                    <td>
                                        <button onClick={() => handleStudentSelect(s.id)} style={{ background: '#10b981', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 15px', cursor: 'pointer' }}>
                                            {selectedStudent === s.id ? 'Assessing' : 'Assess'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {filteredStudents.length === 0 && <p style={{ textAlign: 'center', padding: 20, color: '#666' }}>No students found.</p>}
                </div>
            </div>

            {selectedStudent && history.length > 0 && (
                <div style={{ background: '#fff', padding: 20, borderRadius: 10, boxShadow: '0 4px 10px rgba(0,0,0,0.05)' }}>
                    <h3>Assessment History</h3>
                    <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 10 }}>
                        <thead><tr style={{ background: '#f3f4f6', textAlign: 'left' }}><th>Date Update</th><th>Pre Marks</th><th>Mid Marks</th><th>Post Marks</th><th>Remarks</th></tr></thead>
                        <tbody>
                            {history.map(h => (
                                <tr key={h.id} style={{ borderBottom: '1px solid #ddd' }}>
                                    <td style={{ padding: 10 }}>{new Date(h.created_at).toLocaleString()}</td>
                                    <td>{h.pre_marks ? `${Number(h.pre_marks)}/${h.pre_max_marks ? Number(h.pre_max_marks) : '-'}` : '-'}</td>
                                    <td>{h.mid_marks ? `${Number(h.mid_marks)}/${h.mid_max_marks ? Number(h.mid_max_marks) : '-'}` : '-'}</td>
                                    <td>{h.post_marks ? `${Number(h.post_marks)}/${h.post_max_marks ? Number(h.post_max_marks) : '-'}` : '-'}</td>
                                    <td>{h.remarks}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default HclSatheeAssessment;
